import Role from 'constants/role';
import { useHasRole } from 'hooks/useHasRole';
import React from 'react';
import { ReferenceField, TextField } from 'react-admin';
import VisibilityOffRounded from '@mui/icons-material/VisibilityOffRounded';
import { CopyField } from './CopyField';

function OrganizationIdentifier({
  idField,
  titleField,
}) {
  return (
    <div style={{ display: 'inline-flex', gap: 5 }}>
      {idField && <CopyField source="id" label="ID" />}
      {titleField && <CopyField source="title" />}
    </div>
  );
}
function OrganizationReferenceField({
  titleField,
  serviceField,
  translationTypeField,
  idField,
  ...props
}) {
  const hasRole = useHasRole();
  if (!hasRole(Role.SUPER_ADMIN)) {
    return <VisibilityOffRounded />;
  }
  return (
    <ReferenceField reference="organizations" {...props}>
      <OrganizationIdentifier
        titleField={titleField}
        serviceField={serviceField}
        translationTypeField={translationTypeField}
        idField={idField}
        sx={{
          width: '200px',
        }}
      />
    </ReferenceField>
  );
}
OrganizationReferenceField.defaultProps = {
  source: 'orgId',
  addLabel: true,
  label: 'Organization',
  idField: true,
  titleField: true,
  typeField: false,
};

export default OrganizationReferenceField;
